// Module
var code = "<div class=\"bike-dashboard\">\n\n    <div ng-repeat=\"negotiation in showRequest.negotiationHistory\">\n        <div negotiation=\"negotiation\" set-request=\"setRequest\" request=\"showRequest.request\"></div>\n    </div>\n</div>";
// Exports
var _module_exports = code;;
var path = 'components/request/view/tabs/negotiation/negotiation-history.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;